import { CodeInput } from "@components/Input";
import { OnboardingLayoutProps } from "@components/OnboardingLayout";
import { StorageKey } from "@ctypes";
import { EntryStepLayout as OnboardingLayout } from "@entry/EntryStepLayout";
import { useErrorBanner, useFetchUser, useVerifyEmail } from "@hooks";
import { i18n, Translations } from "@i18n";
import { formatPhoneNumber, getNextRoute } from "@utils";
import { useState } from "react";
import { useNavigate, useLocation } from "@entry/navigation";
import { EmailCodeVerificationRouteProps } from "./types";

const CODE_LENGTH = 6;

export const EmailCodeVerificationRoute = () => {
  const navigate = useNavigate();

  const location = useLocation();

  const phoneNumber = (location.state as EmailCodeVerificationRouteProps)?.phoneNumber ?? "";

  const [code, setCode] = useState("");

  const [verifyEmail, { loading }] = useVerifyEmail();
  const [fetchUser] = useFetchUser();

  const { showErrorBanner } = useErrorBanner();

  const disabled = code.length !== CODE_LENGTH;

  const startVerification = async (code: string) => {
    const { data } = await verifyEmail({
      variables: {
        code,
        phoneNumber,
      },
    });

    const token = data?.verifyEmail.token;

    if (token) {
      localStorage.setItem(StorageKey.Token, token);

      const { data: user } = await fetchUser();
      localStorage.setItem(StorageKey.User, JSON.stringify(user));

      const nextRoute = getNextRoute();

      navigate(nextRoute, { replace: true });
    } else {
      showErrorBanner();
    }
  };

  const props: OnboardingLayoutProps = {
    title: i18n.t(Translations.EmailCodeVerificationRouteTitle),
    subtitle: i18n.t(Translations.EmailCodeVerificationRouteSubtitle, {
      number: formatPhoneNumber(phoneNumber),
    }),
    cta: {
      primary: {
        title: i18n.t(Translations.PhoneVerificationRoutePrimaryCTA),
        onClick: () => startVerification(code),
        loading,
        disabled,
      },
    },
  };

  return (
    <OnboardingLayout {...props}>
      <CodeInput
        length={CODE_LENGTH}
        value={code}
        onChangeText={setCode}
        onComplete={(code: string) => startVerification(code)}
      />
    </OnboardingLayout>
  );
};
